module.exports = __webpack_public_path__ + "static/media/gear.775c1e89.svg";